import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router'

import { Card, Divider, Header, Segment } from 'semantic-ui-react'

import RugCard from 'Components/RugCard'
import Permissions from 'Components/Permissions'

import { THEME_COLOR } from 'Global/constants'

import * as styles from './styles'

const RecentRugsSegment = props => {
  const { items, link, rugs, setCurrentIndex, title, togglePreview, user } = props

  const mapped = rugs.map((r, i) => {
    return (
      <RugCard
        index={i}
        key={r.id}
        picture={r.picture}
        rug={r}
        setCurrentIndex={setCurrentIndex}
        togglePreview={togglePreview}
        user={user}
        enablePreview
        fixedHeight
        noRibbon
      />
    )
  })

  return (
    <Segment color={THEME_COLOR}>
      <Header as="h3" content={title} />
      <Card.Group itemsPerRow={items} stackable>
        {mapped}
      </Card.Group>

      <Divider />

      <Permissions
        permissions="modules.search"
        render={() => (
          <Link to={link} style={styles.moreLink}>
            <p style={styles.showMeMore}>Show me more</p>
          </Link>
        )}
      />
    </Segment>
  )
}

RecentRugsSegment.propTypes = {
  items: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  rugs: PropTypes.array.isRequired,
  setCurrentIndex: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  togglePreview: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default RecentRugsSegment
